import React from 'react';
import WSHandler from 'components/ws-handler';
import Updater from './updater';
import ModalHandler from './modal-handler';

const SideActionsHandler = () => {
    return (
        <>
            <WSHandler/>
            <Updater/>
            <ModalHandler/>
        </>
    )
}

export default SideActionsHandler;